import gql from 'graphql-tag'
export default gql`mutation deleteGradingCurveMutation($gradingCurveId: Int!) {
  deleteGradingCurve(gradingCurveId: $gradingCurveId) {
    success
  }
}`